import React from 'react';
import { Box, Divider, Paper, Typography } from '@mui/material';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, LabelList } from 'recharts';

const renderYAxisTick = ({ x, y, payload }) => (
  <foreignObject x={x - 190} y={y - 10} width={180} height={20}>
    <div
      xmlns="http://www.w3.org/1999/xhtml"
      style={{
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        width: '100%',
        fontSize: '12px',
        textAlign: 'right',
        lineHeight: '20px',
      }}
      title={payload.value}
    >
      {payload.value}
    </div>
  </foreignObject>
);

const CustomTooltip = ({ active, payload, label, color }) => {
  if (!active || !payload?.length) return null;

  const { value } = payload[0];

  return (
    <Paper
      elevation={3}
      sx={{
        minWidth: 220,
        border: `2px solid ${color}`,
        borderRadius: 1,
        overflow: 'hidden',
      }}
    >
      <Box p={1}>
        <Typography variant="subtitle2" sx={{ color: 'text.primary', textAlign: 'left' }}>
          {label}
        </Typography>

        <Divider sx={{ m: 1 }} />

        <Box display="flex" alignItems="center" justifyContent="space-between" mt={1}>
          <Box display="flex" alignItems="center" gap={1}>
            <Box
              sx={{
                width: 10,
                height: 10,
                borderRadius: '50%',
                backgroundColor: color,
              }}
            />
            <Typography variant="body2" color="text.secondary">
              Referrals
            </Typography>
          </Box>
          <Typography variant="body2" fontWeight="bold" color="text.primary">
            {value}
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
};

export default function ReferralBarChart({
  referrals,
  color,
  totalLabel,
  show,
  noDataText = 'No data found',
}) {
  if (!show) {
    return <Typography>{noDataText}</Typography>;
  }

  return (
    <>
      <Box
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 1,
          mb: 2,
        }}
      >
        <Box
          sx={{
            width: 24,
            height: 24,
            backgroundColor: color,
          }}
        />
        <Typography variant="h6" color="text.primary" sx={{ fontSize: 20 }}>
          {totalLabel}
        </Typography>
      </Box>

      <Box sx={{ height: Math.max(referrals.length * 40, 500), width: '100%' }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={referrals} layout="vertical">
            <XAxis type="number" domain={[0, 'dataMax']} allowDecimals={false} />
            <YAxis type="category" width={200} dataKey="name" tick={renderYAxisTick} />
            <Tooltip content={<CustomTooltip color={color} />} />
            <Bar
              dataKey="referrals"
              fill={color}
              isAnimationActive={false}
              activeBar={false}
              onMouseOver={() => { }}
              onMouseLeave={() => { }}
            >
              <LabelList dataKey="referrals" position="insideRight" fill="#fff" />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </Box>
    </>
  );
}
